import React from 'react';
import About from './About';
import Footer from './Footer';

function Home() {
  return (
    <div className="Home">
      <div className="main-content">
        <About />
      </div>
      <Footer />
    </div>
  );
}

export default Home;